import React, { FC } from 'react';

import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';

import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions as clientActions } from '../../../slice';

import { SMSForm } from './SMSForm';

export const EditSMS: FC = () => {
  const { onCancel } = useIntegrations();
  const dispatch = useDispatch();
  const { activeClient } = useSelector(selectIntegrations);

  const onSubmit = data => {
    const payload: ClientsApiEditClientRequest = {
      uuid: activeClient.data?.uuid,
      editClientConfig: {
        name: data.name,
        status: true,
        sns: {
          account_id: data.account?.value,
          topic_arn: data?.topic?.value?.resource_id,
          region: data?.topic?.value?.region,
        },
      },
    };
    dispatch(
      clientActions.updateClientById({
        q: payload,
        onSuccess: () => onCancel(),
      }),
    );
  };

  return <SMSForm handleSubmit={onSubmit} actionType="Update" />;
};
